import { Army, Nullable } from '@Models';
import { TYPES } from '@Types';
import { RequestAction } from '@Repository/RequestAction';
import { ArmyRepository, RequestArmySuccess } from '@Repository/ninthAge';
import { inject, injectable } from 'inversify';
import { Result } from '@Redux/type';
import { MyArsenalAction } from '@Redux/actions';
import { IEntityAction } from '@Redux/IEntityAction';
import { PayloadAction } from '@reduxjs/toolkit';
import armySlice from '@Redux/reducers/ninthage/army.slice';

@injectable()
export class ArmyAction extends IEntityAction<
  number,
  Army,
  RequestArmySuccess
> {
  @inject(TYPES.Repository.ArmyRepository) private _repository!: ArmyRepository;
  @inject(TYPES.Actions.MyArsenalAction)
  private _arsenalArmyAction!: MyArsenalAction;

  protected fetchDataSuccess(item: Army): PayloadAction<Army> {
    return armySlice.actions.setArmy(item);
  }

  protected cacheDataSuccess(item: Army): PayloadAction<Army> {
    return armySlice.actions.setArmy(item);
  }

  protected haveError(message: string): PayloadAction<string> {
    return armySlice.actions.setError(message);
  }

  protected areLoading(bool: boolean): PayloadAction<boolean> {
    return armySlice.actions.setLoading(bool);
  }

  protected getCachedItem({
    entityId,
  }: {
    entityId: number;
  }): Promise<Nullable<Army>> {
    return this._repository.getCachedEntity({ dataId: entityId, locale: null });
  }

  protected async getItem({
    entityId,
  }: {
    entityId: number;
  }): Promise<RequestAction> {
    return this._repository.getArmy({ armyId: entityId, locale: null });
  }

  protected subFetchDataBefore =
    ({ entity }: { entity: Army }): Result<void> =>
    (dispatch) => {
      dispatch(this._arsenalArmyAction.getByArmyCategoryId(entity.categoryId));
    };

  protected subFetchDataAfter =
    ({
      entity,
      cachedItem,
    }: {
      entity: Army;
      cachedItem: Nullable<Army>;
    }): Result<void> =>
    (dispatch) => {
      if (!cachedItem || cachedItem?.categoryId != entity.categoryId) {
        dispatch(
          this._arsenalArmyAction.getByArmyCategoryId(entity.categoryId),
        );
      }
    };
}
